/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'note': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M29.425 29h4.47L29 33.934v-4.47c0-.274.151-.464.425-.464zM34 14.563V28h-5.569c-.274 0-.431.196-.431.47V34H14.497c-.274 0-.497-.29-.497-.563V14.563c0-.273.223-.563.497-.563h18.9c.275 0 .603.29.603.563zm-8.503 11.934A.497.497 0 0 0 25 26h-7a.497.497 0 0 0-.497.497v1.006c0 .274.222.497.497.497h7a.497.497 0 0 0 .497-.497v-1.006zm5-4A.497.497 0 0 0 30 22H18a.497.497 0 0 0-.497.497v1.006c0 .274.222.497.497.497h12a.497.497 0 0 0 .497-.497v-1.006zm0-4A.497.497 0 0 0 30 18H18a.497.497 0 0 0-.497.497v1.006c0 .274.222.497.497.497h12a.497.497 0 0 0 .497-.497v-1.006z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/note.js